/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Seo_Rate_ResultsInputs */

const en_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} per 1,000 results`)
};

const zh_hans1_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每千条结果 ${i?.rate}`)
};

const pt_br2_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por mil resultados`)
};

const es_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por cada 1,000 resultados`)
};

const fr_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pour 1 000 résultats`)
};

const de_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pro 1.000 Ergebnisse`)
};

const ru_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} за 1000 результатов`)
};

const it_seo_rate_results = /** @type {(inputs: Seo_Rate_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} ogni 1.000 risultati`)
};

/**
* | output |
* | --- |
* | "{rate} per 1,000 results" |
*
* @param {Seo_Rate_ResultsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_rate_results = /** @type {((inputs: Seo_Rate_ResultsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Rate_ResultsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_rate_results(inputs)
	if (locale === "pt-BR") return pt_br2_seo_rate_results(inputs)
	if (locale === "es") return es_seo_rate_results(inputs)
	if (locale === "fr") return fr_seo_rate_results(inputs)
	if (locale === "de") return de_seo_rate_results(inputs)
	if (locale === "ru") return ru_seo_rate_results(inputs)
	if (locale === "it") return it_seo_rate_results(inputs)
	return en_seo_rate_results(inputs)
});